import type { MarkingSection } from '#shared/utils/markings/schema'
import { markingSectionSchema } from '#shared/utils/markings/schema'
import { array, maxLength, pipe, safeParse } from 'valibot'

const sectionPathSchema = pipe(array(markingSectionSchema), maxLength(64))

export function readSectionPath(root: Element): MarkingSection[] {
  const container = root.closest('[data-marking-section-path]')

  if (container?.getAttribute('data-marking-document-id') !== root.getAttribute('data-marking-document-id')
    || container?.getAttribute('data-marking-content-type') !== root.getAttribute('data-marking-content-type')) {
    return []
  }

  const value = container?.getAttribute('data-marking-section-path')

  if (!value) {
    return []
  }

  try {
    const parsed = safeParse(sectionPathSchema, JSON.parse(value))
    return parsed.success ? parsed.output : []
  }
  catch {
    return []
  }
}
